import React from 'react';

import Icon from '../Icon/Icon';

const DevicesIcon = (props) => {
    return (
        <Icon width='24' height='24' fill='none' {...props}>
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M7.23674 21.9999C6.94295 22.0003 6.65198 21.9437 6.38055 21.8333C6.10913 21.723 5.86259 21.5611 5.65512 21.357C5.44711 21.1534 5.28215 20.9114 5.16973 20.6451C5.0573 20.3787 4.99962 20.0931 5 19.8048V6.14626C4.99974 6.0501 5.01885 5.95484 5.05622 5.86594C5.0936 5.77705 5.14851 5.69629 5.21779 5.62829C5.28708 5.56029 5.36937 5.50641 5.45995 5.46973C5.55053 5.43305 5.6476 5.4143 5.74558 5.41455H8.7279C9.75779 5.41455 10.6893 5.82431 11.3643 6.48577C11.7109 6.82518 11.9858 7.22849 12.1732 7.67251C12.3605 8.11654 12.4565 8.59252 12.4558 9.07309V21.9999H7.23674Z'
                stroke='#393E44'
                strokeWidth='1.5'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M12.7866 22C12.4929 22.0002 12.2022 21.9436 11.9309 21.8332C11.6597 21.7229 11.4133 21.5611 11.2059 21.3571C10.9976 21.1536 10.8322 20.9117 10.7195 20.6454C10.6067 20.379 10.5487 20.0933 10.5488 19.8049V2.34146L14.7738 2C15.9409 2 16.9966 2.46439 17.7621 3.21463C18.155 3.5992 18.4666 4.05617 18.679 4.55929C18.8914 5.06241 19.0004 5.60175 18.9997 6.14634V21.7561L12.7866 22Z'
                fill='#FFFDFB'
                stroke='#393E44'
                strokeWidth='1.5'
            />
        </Icon>
    );
};

export default DevicesIcon;
